<template>
	<!-- This is used to go a page back or whatever is instructed -->
	<div @click="goto">
		<div class="back-btn">
			<div class="h-100 d-flex">
				<h1 class="my-auto">{{ text }}</h1>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	name: "BackButton",
	props: {
		text: String,
		link: String,
	},
	methods: {
		goto() {
			if (this.link === undefined) {
				this.$router.go(-1);
			} else {
				this.$router.push({ name: this.link });
			}
		},
	},
};
</script>

<style scoped>
.back-btn {
	right: 136px;
	top: 45px;
	height: 75px;
	position: absolute;
	clip-path: polygon(15% 0, 100% 0%, 100% 100%, 15% 100%, 0% 50%);
	background-color: #fff;
	z-index: var(--global-z-index-back-btn);
}
.back-btn h1 {
	color: #000;
	font-size: 22px;
	font-weight: bold;
	margin-right: 15px;
	margin-left: 50px;
}
</style>